module.exports = __webpack_public_path__ + "static/img/5.4cfb068.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/eng/5.png
// module id = Th5/
// module chunks = 0